// Pages
import Home from './Home';
import Search from './Search';
import Submit from './Submit';
import Receipt from './Receipt';
export default { Home, Search, Submit, Receipt };
